<template>

    <footer class="footer" id="footer">
        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/footer_big_phone.png" alt="big_phone" class="footer_big_phone">
        <div class="footer_content">
            <div class="container">
                <div class="first_row">
                    <div class="first_row_item">
                        <h2>Информация</h2>
                        <ul>
                            <li> <router-link to="/about">О проекте</router-link> </li>
                            <li> <router-link to="/restaurants_services">Для ресторанов и служб доставки</router-link> </li>
                            <li> <router-link to="/rules">Пользовательское соглашение</router-link> </li>
                            <li> <router-link to="/affiliate">Заработать с нами</router-link> </li>
                            <li> <router-link to="/contacts">Контакты</router-link> </li>
                            <li> <router-link to="/blog">Блог</router-link> </li>
                            <li class="footer_gift" ><router-link to="/present">Подарки</router-link> </li>
                        </ul>
                    </div>
                    <div class="first_row_item">
                        <h2>Доставка блюд</h2>
                        <ul>
                            <li> <router-link to="/pizza">Доставка пиццы</router-link> </li>
                            <li> <router-link to="/sushi">Доставка суши</router-link> </li>
                            <li> <router-link to="/snacks">Доставка закусок</router-link> </li>
                            <li> <router-link to="/burger">Доставка бургеров</router-link> </li>
                            <li> <router-link to="/dessert">Доставка десертов</router-link> </li>
                            <li> <router-link to="/cancer">Доставка раков</router-link> </li>
                            <li> <router-link to="/pie">Доставка осетинских пирогов</router-link> </li>
                            <li> <router-link to="/barbecue">Доставка шашлыков</router-link> </li>
                            <li> <router-link to="/salad">Доставка салатов</router-link> </li>
                            <li> <router-link to="/cakes">Доставка тортов</router-link> </li>
                            <li> <router-link to="/coffee">Доставка кофе</router-link> </li>
                            <li> <router-link to="/lunch">Бизнес-ланчи</router-link> </li>
                            <li> <router-link to="/healthy">Здоровое питание</router-link> </li>
                        </ul>
                    </div>
                    <div class="first_row_item big">
                        <h2>Кухни мира</h2>
                        <ul>
                            <li> <router-link to="/authors_cuisine">Авторская</router-link> </li>
                            <li> <router-link to="/asian">Азиатская</router-link> </li>
                            <li> <router-link to="/united-states">Американская</router-link> </li>
                            <li> <router-link to="/armenian">Армянская</router-link> </li>
                            <li> <router-link to="/balkan">Балканская</router-link> </li>
                            <li> <router-link to="/eastern">Восточная</router-link> </li>
                            <li> <router-link to="/georgian">Грузинская</router-link> </li>
                            <li> <router-link to="/kids">Детская</router-link> </li>
                            <li> <router-link to="/diet">Диетическая</router-link> </li>
                            <li> <router-link to="/european">Европейская</router-link> </li>
                        </ul>
                        <ul>
                            <li> <router-link to="/indian">Индийская</router-link> </li>
                            <li> <router-link to="/italian">Итальянская</router-link> </li>
                            <li> <router-link to="/caucasian">Кавказская</router-link> </li>
                            <li> <router-link to="/chinese">Китайская</router-link> </li>
                            <li> <router-link to="/korean">Корейская</router-link> </li>
                            <li> <router-link to="/mexican">Мексиканская</router-link> </li>
                            <li> <router-link to="/russian">Русская</router-link> </li>
                            <li> <router-link to="/slavic">Славянская</router-link> </li>
                            <li> <router-link to="/exotic">Экзотическая</router-link> </li>
                            <li> <router-link to="/japan">Японская</router-link> </li>
                      </ul>
                    </div>
                </div>
                <div class="second_row">
                    <h2>Мы везде</h2>
                    <div class="footer_icons">
                        <a href="https://vk.com/hochu.poest"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/vk.svg" alt="vk_icon"></a>
                        <a href="https://www.facebook.com/Хочу-поестьрф-Доставка-еды-199220007313152/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/facebook.svg" alt="vk_icon"></a>
                        <a href="https://ok.ru/group/58470704152624"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/ok.svg" alt="vk_icon"></a>
                        <a href="https://www.instagram.com/hochu.poest.rf/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/insta.svg" alt="vk_icon"></a>
                        <a href="https://www.youtube.com/channel/UCn5wSiKQL9EJ3MzvYEjtL3A/"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/youtoobe.svg" alt="vk_icon"></a>
                        <a href="https://twitter.com/hochu_poest"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/twitter.svg" alt="vk_icon"></a>
                        <a href="https://telegram.me/hochu_poest"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/telega.svg" alt="vk_icon"></a>
                    </div>
                    <p>Acheive right now</p>
                </div>
                <div class="third_row">
                    <div class="column">
                        <div class="links_box">
                          <div class="open_map_wrapp">
                              <router-link to="/franchise" class="open_map">Открой</router-link>
                          </div>
                          <div class="invest">
                              <router-link to="/investment" class="open_map">Инвестируй</router-link>
                          </div>
                        </div>
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/wte_footer.svg" alt="" class="footer_logo">
                        <p>В своем городе</p>
                    </div>
                    <div class="column">
                        <p>Заказывайте еще быстрее<br>
                            через мобильное приложение
                        </p>
                        <div class="google_apple">
                            <a href="https://play.google.com/store/apps/details?id=com.imabuilder.wanttoeat.wanttoeat" target="_blank"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/google_play.svg" alt="google_play"></a>
                            <a href="https://apps.apple.com/app/id1447938345" target="_blank"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/app_store.svg" alt="app_store"></a>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="footer_bottom_line">
            <div class="container">
                <router-link tag="div" to="/franchise" class="copyright">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/copy_right.svg" alt="">
                    <p>"Хочу поесть" Все права защищены</p>
                </router-link>
                <div class="flags">
                    <a href="#"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/ukr.svg" alt="ukraine"></a>
                    <a href="#"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/belarus.svg" alt="belarus"></a>
                    <a href="#"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/kaz.svg" alt="kz"></a>
                    <a href="#"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/footer/euro.svg" alt=""></a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'footerMenu',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footerMenu.vue